import React, { useState } from "react";
import ReactDOM from "react-dom";
import ReactPlayer from "react-player";
import { Img } from "react-image";
import styles from "../communication-chat.module.css";
import { Download, X } from "react-feather";

const MessageFileViewer = (props) => {
  const [fullImageUrl, setFullImageUrl] = useState(null);

  const handleDownload = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = "file"; // Set the desired filename for the downloaded file
    link.click();
  };

  const renderFileContent = (fileUrl, contentType) => {
    if (contentType.startsWith("image/")) {
      return (
        <div
          onClick={() => setFullImageUrl(fileUrl)}
          className={`${styles.ImgFile}`}
        >
          <Img src={fileUrl} alt="Image" />
        </div>
      );
    } else if (contentType.startsWith("video/")) {
      return (
        <div className={`${styles.ImgFile}`}>
          <ReactPlayer url={fileUrl} controls />
        </div>
      );
    } else if (contentType.startsWith("audio/")) {
      return (
        <div className={`${styles.AudioFileContainer}`}>
          <audio src={fileUrl} controls />
        </div>
      );
    } else {
      return (
        <div>
          <p className={`${styles.NoFileTT}`}>
            This file type is not supported for preview.
          </p>
          <button
            className={`${styles.NoFileDrBU}`}
            onClick={() => handleDownload(fileUrl)}
          >
            Download File
          </button>
        </div>
      );
    }
  };

  return (
    <>
      {props.media.map((file, index) => (
        <div key={index}>
          {renderFileContent(file.url, file.content_type)}
        </div>
      ))}
      {fullImageUrl &&
        ReactDOM.createPortal(
          <div
            className={`${styles.ImgFilePops} ${styles.Active}`}
            onClick={() => setFullImageUrl(null)}
          >
            <Img
              src={fullImageUrl}
              alt="Image"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              onClick={() => setFullImageUrl(null)}
              className={`${styles.CancelImgBU}`}
            >
              <X />
            </button>
          </div>,
          document.body
        )}
    </>
  );
};

export default MessageFileViewer;
